<template>
	<div>
		<div class="only-desktop-flex w-full rounded-zt border border-zt-light bg-zt-dark items-center py-3.5"
         :class="{ 'justify-between pr-4 pl-2': isTdPost }">
			<div class="flex flex-col gap-1.5">
				<a :href="getBookiePromoLink(bookmaker)" class="no-default-style">
					<img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${ bookmaker }.svg`"
							 class="object-cover zt-hover rounded-zt"
							 :class="isTdPost ? 'ml-3 min-w-[114px] w-[114px] h-[68px]' : 'ml-[100px]'"
							 width="159" height="97"/>
				</a>
			<span v-if="isTdPost"
						class="py-[3px] px-2.5 rounded-zt bg-[#CE2121] text-xs font-medium text-center ml-3" v-html="bonusEndTime"
						data-bs-toggle="tooltip" data-bs-placement="top" data-bs-delay="500" :title="bonusDetailedEndTime"></span>
			</div>
			<div v-if="!isTdPost" class="flex flex-col items-center w-[140px] ml-[104px] gap-y-[14px]">
				<span class="py-0.5 px-2.5 rounded-lg bg-[#CE2121] text-sm" v-html="bonusEndTime"
							data-bs-toggle="tooltip" data-bs-placement="top" data-bs-delay="500" :title="bonusDetailedEndTime"></span>
				<span v-if="areOddsSet"
							class="text-[#222] font-bold py-[6px] bg-zt-more border border-zt-more"
              :class="isTdPost ? 'text-lg px-5' : 'text-2xl px-[25px]'"
						  style="border-radius: 12.568px 12.568px 0px 12.568px;">{{ odds }}</span>
				<div v-else class="flex flex-col text-center text-[#F7CE4A] font-semibold text-[18px]"
             :class="{ 'gap-y-1.5': !isTdPost }">
					<span class="flex">
						<span v-for="index in Math.floor(starRating)">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
								<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#F2A640" stroke="#F7CE4A"/>
							</svg>
						</span>
						<span v-if="starRating - Math.floor(starRating) === 0.5" class="relative">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#B4B4B4" stroke="#BFBFBF"/>
								<path d="M7.16846 11.1244L3.86888 13.6908L5.12235 9.01809L5.20601 8.70619L4.95614 8.50165L1.78528 5.90597L5.77165 5.61008L6.07038 5.58791L6.19176 5.31405L7.5 2.36219V5.11146V7.2918V8.88854V10.7929L7.16846 11.1244Z" fill="#F2A640" stroke="#F7CE4A"/>
							</svg>
						</span>
						<span v-for="index in (5 - Math.round(starRating))">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
								<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#B4B4B4" stroke="#BFBFBF"/>
							</svg>
						</span>
					</span>
					<span v-if="Math.round(starRating) === 5" :class="{ 'uppercase': isTdPost }">
						Idealny!
					</span>
					<span v-else-if="Math.round(starRating) === 4" :class="{ 'uppercase': isTdPost }">
						Super!
					</span>
					<span v-else-if="Math.round(starRating) === 3" :class="{ 'uppercase': isTdPost }">
						Dobry!
					</span>
				</div>
			</div>
			<div class="flex flex-col text-center" :class="isTdPost ? 'ml-px w-[270px]' : 'ml-[95px] w-[310px]'">
				<span v-if="areOddsSet" class="uppercase"
              :class="isTdPost && window.size.desktop ? 'text-[28px] font-bold' : 'text-[18px] font-semibold'">
          {{ isTdPost && window.size.desktop ? 'BOOST' : 'Podwyższony kurs' }}
        </span>
				<span v-else class="uppercase font-bold text-[34px]"
              :class="{ 'min-w-[132px] -ml-1.5 truncate': isTdPost }">{{ amount }}</span>
				<span class="font-medium uppercase opacity-70"
              :class="[{ 'pt-[14px]': areOddsSet && !isTdPost }, { 'line-clamp-2 text-sm': isTdPost }]">{{ name }}</span>
			</div>
			<div class="flex flex-col items-center justify-center" :class="isTdPost ? 'gap-y-3.5' : 'ml-[103px] gap-y-2'">
				<a class="no-default-style zt-hover cursor-pointer py-3 rounded-zt bg-zt-red uppercase text-sm 
					   font-semibold text-center"
           :class="isTdPost ? 'w-[150px] px-3.5' : 'w-[252px] px-4'"
					 @click="handleClick(bonusLink, '_blank')">Odbierz bonus</a>
				<a class="no-default-style zt-hover border w-[252px] justify-center h-[44px] rounded-zt border-zt-light cursor-pointer flex items-center gap-x-[6px]
					   text-sm font-semibold uppercase"
					 :class="{ 'text-xs !w-[150px]': isTdPost }"
					 @click="handleClick(postLink, '_blank', 'info')">
					Szczegóły bonusu
				</a>
			</div>
		</div>
		<div class="only-mobile-flex flex-col items-center min-h-[399px] max-h-[999px] bg-zt-dark border border-zt-light rounded-lg">
			<a :href="getBookiePromoLink(bookmaker)" class="no-default-style">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/${ bookmaker }.svg`"
				     class="object-cover zt-hover rounded-b-[9px] border-t border-zt-light"
				     width="127" height="64"/>
			</a>
			<div class="pt-[20px] text-center">
				<span class="flex">
					<span v-for="index in Math.floor(starRating)">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
							<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#F2A640" stroke="#F7CE4A"/>
						</svg>
					</span>
					<span v-if="starRating - Math.floor(starRating) === 0.5" class="relative">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#B4B4B4" stroke="#BFBFBF"/>
							<path d="M7.16846 11.1244L3.86888 13.6908L5.12235 9.01809L5.20601 8.70619L4.95614 8.50165L1.78528 5.90597L5.77165 5.61008L6.07038 5.58791L6.19176 5.31405L7.5 2.36219V5.11146V7.2918V8.88854V10.7929L7.16846 11.1244Z" fill="#F2A640" stroke="#F7CE4A"/>
						</svg>
					</span>
					<span v-for="index in (5 - Math.round(starRating))">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
							<path d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z" fill="#B4B4B4" stroke="#BFBFBF"/>
						</svg>
					</span>
				</span>
				<div class="pt-[6px] text-[18px] font-semibold text-[#F7CE4A]">
					<span v-if="Math.round(starRating) === 5">
						Idealny!
					</span>
					<span v-else-if="Math.round(starRating) === 4">
						Super!
					</span>
					<span v-else-if="Math.round(starRating) === 3">
						Dobry!
					</span>
				</div>
			</div>
			<div class="px-6 w-full pt-4">
				<hr class="border-t w-full border-zt-light border-dashed" />
			</div>
			<div class="pt-[26px]">
				<span class="py-0.5 px-[6px] rounded-lg bg-[#CE2121] text-sm" v-html="bonusEndTime"
							data-bs-toggle="tooltip" data-bs-placement="top" data-bs-delay="500" :title="bonusDetailedEndTime"></span>
			</div>
			<div v-if="areOddsSet" class="pt-[22px]">
				<span class="text-[#222] text-xl font-bold py-[5px] px-[18px] bg-zt-more border border-zt-more rounded-[14px]">
					{{ odds }}
				</span>
			</div>
			<div class="px-4 text-center" :class="areOddsSet ? 'pt-[20px] pb-1' : 'pt-[11px]'">
				<span v-if="areOddsSet" class="uppercase text-base font-semibold">Podwyższony kurs</span>
				<span v-else class="uppercase text-[30px] font-bold">{{ amount }}</span>
			</div>
			<div class="text-center px-4" :class="{ 'pt-2' : areOddsSet }">
				<span class="text-base font-medium uppercase opacity-70" :class="{ 'pt-[14px]' : areOddsSet }">
					{{ name }}
				</span>
			</div>
			<div v-if="showPromoCode" class="flex mt-6 flex-col mb-4 items-center gap-1">
				<span class="text-xs text-white/70">Kod promocyjny</span>
				<div class="relative w-[252px] h-[45px] bg-white rounded-zt border border-dashed border-black
                   cursor-pointer zt-hover"
				     @click="copyToClipBoard()">
              <span class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-xl font-bold text-black">
                {{ code }}
              </span>
					<div class="h-8 w-8 absolute top-2.5 right-3 bg-cover
                     bg-[url(/wp-content/themes/zawodtyper/assets/images/ikona_kopiowanie.svg)]"></div>
				</div>
			</div>
			<a class="no-default-style zt-hover cursor-pointer py-3 px-4 rounded-zt bg-zt-red uppercase text-sm
				   font-semibold w-[252px] text-center"
			   :class="{ 'mt-6' : !showPromoCode }"
				 @click="handleClick(bonusLink, '_blank')">Odbierz bonus</a>
			<a class="mt-[14px] mb-6 no-default-style zt-hover cursor-pointer flex items-center gap-x-[6px] border border-zt-light w-[252px] justify-center h-[44px] rounded-zt
				   text-sm font-semibold uppercase" @click="handleClick(postLink, '_blank', 'info')">
				Szczegóły bonusu
			</a>
		</div>
	</div>
</template>

<script>
import { countClicks } from "../../../assets/js/utils";
import utils_mixin from "../../mixins/utils_mixin";
import {Notice} from "../../../assets/js/Notice";

export default {
	name: 'LimitedTimeBonus',
	inject: ['WP'],
	props: {
		data: {
			type: Object,
			required: true,
		},
		isTdPost: {
			type: Boolean,
			default: false
		},
		analytic: {
			type: String,
			required: false,
		},
		showPromoCode: {
			type: Boolean,
			default: false
		}
	},
	mixins: [utils_mixin],
	data() {
		return {
			bonus: this.data.limited_time_bonus,
		}
	},
	mounted() {
		setTimeout(this.refreshTooltips, 300);
	},
	computed: {
		bookmaker() {
			return this.bonus.bookmaker_name.toLowerCase();
		},
		amount() {
			return this.bonus.bonus_amount;
		},
		bonusEndTime() {
			const phrase = window.size.mobile ? 'Do końca' : 'Zostało';
			const endTime = DateTime.fromSQL(this.bonus.bonus_end_time);
			const now = DateTime.now();
			const diff = endTime.diff(now, ['days' ,'hours', 'minutes']).toObject();
			if (diff.days >= 1) {
				return `${ phrase }:  <span class="font-semibold">${ diff.days } ${diff.days > 1 ? 'dni' : 'dzień'}</span>`;
			} else if (diff.hours >= 1) {
				return `${ phrase }:  <span class="font-semibold">${ diff.hours } godz. </span>`;
			} else if (diff.minutes >= 1) {
				return `${ phrase }: <span class="font-semibold">${ Math.round(diff.minutes) } min.</span>`;
			} else {
				return 'Zakończono';
			}
		},
		bonusDetailedEndTime() {
			const endTime = DateTime.fromSQL(this.bonus.bonus_end_time);
			const formattedEndTime = endTime.toFormat('dd.MM.yyyy, HH:mm');
			return formattedEndTime;
		},
		starRating() {
			return Math.round(+this.bonus.star_rating * 2) / 2;
		},
		code() {
			return this.bonus.code;
		},
		name() {
			return this.bonus.bonus_name;
		},
		areOddsSet() {
			return this.odds !== '';
		},
		odds() {
			return this.bonus.bonus_odds;
		},
		bonusLink() {
			return this.bonus.receive_bonus_link;
		},
		postLink() {
			return this.bonus.post_link;
		}
	},
	methods: {
		copyToClipBoard() {
			if (window.size.mobile) {
				navigator.clipboard.writeText(this.code);
				this.addInternalNotification(new Notice().setContent('Skopiowano kod promocyjny'));
				this.countClicks('Analityka bez depozytu - SKOPIUJ TYPERVIP');
			}
		},
		handleClick(link, target, type = 'code') {
      if (this.analytic === 'NP') {
        countClicks('Bonusy okazjonalne w Nowej PN');
        return;
      }
			if (this.isTdPost) {
				countClicks('Typy Dnia - Aktywne bonusy z limitem czasowym');
			} else {
				if (this.WP.id === 9250) {
					countClicks('Ranking vs Bez Depozytu - Bez depozytu');
				}
				countClicks(`${this.analytic} - ${ type === 'code' ? 'A' : 'B' }`);
      }
      axios.post(WP.ajaxUrl, {
        endpoint: 'api_count_outerlink_click',
        link: link,
      });
      window.open(link, target);
		}
	}
}

</script>